export const lerp = (a: number, b: number, n: number) => (1 - n) * a + n * b;
export const distance = (x1: number, y1: number, x2: number, y2: number) =>
	Math.hypot(x2 - x1, y2 - y1);
